// extracted by mini-css-extract-plugin
module.exports = {"sideBannerContent":"styles_sideBannerContent__1H1eF","slideInRight":"styles_slideInRight__2hMZz","logoContainer":"styles_logoContainer__1Knh2","demoTag":"styles_demoTag__Nd9Pp"};